import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';
import { SystemErrorView } from 'components/SystemError/SystemError.view';
import { RematchContext } from 'models/rematchStore';

const mapState = ({ appData }) => ({
    modelError: appData.modelError,
});

const isRenderingValid = ({ modelError }) => !modelError;

const enhanced = compose(
    connect(mapState, undefined, undefined, { context: RematchContext }),
    branch(isRenderingValid, renderNothing)
);

export const SystemError = enhanced(SystemErrorView);
